import type React from 'react';

import type { ControlSize } from './control';
import type { PressableProps } from './pressable';
import type { SurfaceColor } from './surfaceColor';

export interface CheckboxProps extends Omit<
  PressableProps,
  'accessibilityRole' | 'accessibilityState' | 'children' | 'onPress' | 'style'
> {
  children?: React.ReactNode;
  checked?: boolean;
  defaultChecked?: boolean;
  onCheckedChange?: ((checked: boolean) => void) | undefined;
  color?: SurfaceColor;
  size?: ControlSize;
  invalid?: boolean;
  readOnly?: boolean;
}
